/* ==========================================================================
   Mill tapestry palette — the real thing, parsed from the mill's swatch file

   These are not yarn colours. the mill weaves with six warp colours (white,
   black, green, red, blue, yellow) and two weft colours (black and white),
   and each of these 147 entries is a distinct WEAVE STRUCTURE built from
   those eight threads. Their own note: "The colors are not flat colors, but
   rather a complex interlacing of colorful tapestry warp threads with white
   and black weft threads."

   Which means the RGB values below already describe how the cloth looks when
   woven. The simulator indexes straight to them rather than trying to model
   the interlacing itself — the mill has already done that work, and done it
   on their own looms.

   Source: the mill's swatch file (147 swatches) + the mill's artist info pack.
   Do not hand-edit. Regenerate from the .aco if they issue a new palette.
   ========================================================================== */
(function () {
  'use strict';
  window.BS_WEAVE_PALETTE = [
    [249,249,249], [243,215,211], [251,185,173], [227,145,129],
    [237,127,122], [237,153,155], [209, 94, 94], [151, 53, 60],
    [131, 30, 19], [126, 19, 26], [ 90, 12, 12], [ 59,  5,  2],
    [249,245,215], [243,237,191], [245,231,153], [245,227,118],
    [195,165, 71], [143,109,  7], [127, 93, 20], [ 55, 44,  2],
    [227,223,185], [225,225,161], [217,215,131], [169,161, 72],
    [ 98, 95,  5], [ 92, 91, 13], [ 51, 55,  1], [217,215,187],
    [129,131, 98], [ 84, 84, 52], [225,239,249], [203,223,249],
    [157,185,229], [165,201,233], [ 99,116,157], [ 63, 81,139],
    [  4, 44,103], [  3, 35, 85], [  1, 18, 44], [227,249,199],
    [221,247,157], [167,195, 90], [147,195, 90], [137,175, 61],
    [102,129, 27], [ 83,103, 30], [ 48, 79,  2], [ 38, 47,  1],
    [225,255,231], [199,243,203], [187,237,183], [145,227,159],
    [126,205,149], [ 88,171,108], [ 81,149, 90], [ 71,123, 78],
    [  3, 82, 13], [  2, 70, 10], [  1, 45,  6], [157,203,171],
    [135,195,157], [107,177,129], [ 64,126, 90], [  3, 70, 36],
    [225,215,243], [191,169,219], [125,105,183], [ 88, 66,135],
    [ 73, 48,123], [ 51, 21, 84], [ 29,  5, 41], [253,231,207],
    [255,207,139], [251,189,108], [247,191,101], [251,169, 80],
    [245,126, 54], [241,117, 81], [165, 80,  3], [155, 53,  3],
    [223,245,249], [ 76,159,165], [  7,135,139], [  0, 97,100],
    [  1, 40, 43], [211,145,175], [179, 96,114], [101,  6, 30],
    [243,215,229], [187,117,165], [167, 84,141], [135, 64,112],
    [112, 26, 77], [ 90, 14, 59], [ 66,  8, 42], [239,169,124],
    [223,155, 99], [157, 94, 55], [139, 83, 33], [112, 64, 35],
    [117, 48, 28], [ 95, 43, 11], [ 79, 57, 16], [ 33, 16, 12],
    [197,157, 94], [209,169,125], [171,133, 90], [137,102, 64],
    [121, 80, 31], [ 88, 55, 17], [ 46, 28,  5], [141,135,112],
    [139,119, 94], [213,215,215], [175,193,199], [114,121,129],
    [ 96, 96, 98], [ 74, 84, 91], [ 39, 47, 59], [ 46, 46, 48],
    [  0,  0,  3], [193,209,213], [215,229,229], [201,227,229],
    [169,205,211], [139,193,209], [203,237,249], [169,193,219],
    [139,153,201], [ 99,131,157], [149, 99, 88], [104,129,149],
    [ 66,100,118], [ 39, 78, 95], [126,165,175], [ 76,114,131],
    [187,107,167], [155, 78,141], [ 98, 17, 55], [239,223,181],
    [159,120, 79], [157,143,108], [107, 78, 27], [205,197,126],
    [165,153, 75], [106, 98, 31], [153,153,153]
  ];
  window.BS_WEAVE_NAMES = ["1-R5", "2-130", "3-131", "4-132", "5-133", "6-134", "7-135", "8-136", "9-137", "10-138", "11-139 ", "12-140", "13-50", "14-51", "15-52", "16-53", "17-54", "18-55", "19-56", "20-57", "21-20", "22-21", "23-22", "24-23", "25-24", "26-25", "27-26", "28-30", "29-31", "30-32", "31-760", "32-761", "33-762", "34-763", "35-764", "36-765", "37-766", "38-767", "39-768", "40-301", "41-302", "42-303", "43-304", "44-305", "45-306", "46-307", "47-308", "48-309", "49-180", "50-182", "51-183", "52-184", "53-185", "54-186", "55-187", "56-188", "57-189", "58-190", "59-191", "60-205", "61-206", "62-207", "63-208", "64-209", "65-160", "66-161", "67-162", "68-163", "69-164", "70-165", "71-166", "72-111", "73-112", "74-113", "75-114", "76-115", "77-116", "78-117", "79-118", "80-119", "81-40", "82-41", "83-42", "84-43", "85-44", "86-62", "87-63", "88-64", "89-245", "90-246", "91-247", "92-248", "93-249", "94-250", "95-251", "96-411", "97-412", "98-413", "99-414", "100-415", "101-416", "102-417", "103-418", "104-419", "105-520", "106-521", "107-522", "108-523", "109-524", "110-526", "111-527", "112-84", "113-85", "114-2", "115-3", "116-4", "117-5", "118-6", "119-7", "120-8", "121-15", "122-710", "123-711", "124-712", "125-713", "126-714", "127-730", "128-731", "129-732", "130-733", "131-410", "132-736", "133-737", "134-738", "135-734", "136-739", "137-252", "138-253", "139-254", "140-86", "141-87", "142-88", "143-528", "144-601", "145-602", "146-603", "147-9"];
})();
